export default {
  "b2b.provozni-informace.page-heading": "Správa provozních informací",
  "b2b.provozni-informace.page-heading.action-filter": "Filtrovat",
  "b2b.provozni-informace.page-heading.action-add": "Nová informace"
};
